import { useMutation } from '@tanstack/react-query';
import * as Sentry from '@sentry/react';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '../app/routes/Routes';
import {
  SubmissionPayload,
  SubmissionResponse,
} from '@abvehicles/types/api-types';
import { useAbVehiclesStore } from '@abvehicles/store/store';

function isSuccessfulSubmissionResponse(data: any): data is SubmissionResponse {
  return (
    data &&
    typeof data === 'object' &&
    'case_reference' in data &&
    'sla_text' in data
  );
}

const submitData = async (payload: SubmissionPayload) => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_APIM_BASE_URL}/report/v1/vehicles/abandoned`,
      {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Ocp-Apim-Subscription-Key': `${import.meta.env.VITE_APIM_API_KEY as string}`,
          'content-type': 'application/json',
        },
      },
    );
    const data = await response.json();
    if (isSuccessfulSubmissionResponse(data)) {
      return data;
    } else {
      throw new Error('Failed to submit report');
    }
  } catch (error) {
    throw new Error((error as Error).message);
  }
};

export const useHandleSubmit = () => {
  const navigate = useNavigate();
  const { updateCaseReferenceId } = useAbVehiclesStore();

  return useMutation({
    mutationFn: submitData,
    onSuccess: (data) => {
      if (data && isSuccessfulSubmissionResponse(data)) {
        updateCaseReferenceId(data.case_reference);
      }
    },
    onError: (error) => {
      Sentry.captureException(error);
      navigate(RoutesList.INTERNAL_SERVER_ERROR);
    },
  });
};
